var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHungry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F9F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5008 48.4029C40.3884 48.4029 48.4039 40.3874 48.4039 30.4998C48.4039 20.6122 40.3884 12.5967 30.5008 12.5967C20.6132 12.5967 12.5977 20.6122 12.5977 30.4998C12.5977 40.3874 20.6132 48.4029 30.5008 48.4029Z",
    stroke: "#1E1E1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9609 27.1621C21.18 25.4046 22.5356 24.0514 24.1755 24.0514C25.8153 24.0514 27.171 25.4046 27.39 27.1621",
    stroke: "#1E1E1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6133 27.1621C33.8323 25.4046 35.188 24.0514 36.8278 24.0514C38.4676 24.0514 39.8233 25.4046 40.0424 27.1621",
    stroke: "#1E1E1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5959 31.7714C39.1443 35.7523 34.9171 37.9041 30.5011 37.9041C26.0851 37.9041 21.8579 35.7523 19.4062 31.7714",
    stroke: "#1E1E1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.793 37.8588C32.8024 37.7535 33.6546 36.5977 33.6316 35.5007C33.6251 35.1936 33.6249 34.303 33.6264 33.1958C33.6281 31.8409 34.7268 30.7432 36.082 30.7432C37.4392 30.7432 38.5391 31.8446 38.5376 33.2018C38.5369 33.8148 38.5364 33.8639 38.5364 34.0158C38.5364 34.4387 38.4388 35.239 37.9883 35.5905",
    stroke: "#1E1E1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1594 32.895V34.9395C36.1594 35.4652 36.223 36.716 35.4062 36.9762",
    stroke: "#1E1E1D",
    strokeWidth: 1.19351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHungry);
export default __webpack_public_path__ + "static/media/hungry.7d1e36c535d3c1d444b5004077894158.svg";
export { ForwardRef as ReactComponent };